import { useState, type ReactNode } from 'react';
import { FormDialog, FormDialogBody, FormDialogContent, FormDialogTitle } from './form-dialog';

/** Ponte para os formulários existentes: mantém conteúdo e regras, padroniza foco e fechamento. */
export function CenteredDialog({ title, onClose, children }: { title: string; onClose: () => void; children: ReactNode }) {
  // Captura antes de montar os filhos, que podem focar o primeiro campo por efeito próprio.
  const [acionador] = useState(() => document.activeElement instanceof HTMLElement ? document.activeElement : null);
  return <FormDialog open onOpenChange={open => { if (!open) onClose(); }}>
    <FormDialogContent size="wide" aria-describedby={undefined} className="legacy-centered-dialog" onCloseAutoFocus={(evento) => { if (acionador?.isConnected) { evento.preventDefault(); acionador.focus(); } }}>
      <FormDialogTitle className="sr-only">{title}</FormDialogTitle>
      <FormDialogBody className="p-0">{children}</FormDialogBody>
    </FormDialogContent>
  </FormDialog>;
}
